import React, { ReactNode } from 'react';

import Box from 'components/Box';
import { FacebookButton, GoogleButton } from 'components/Button';
import Divider from 'components/Divider';
import Form, {
  GeneralError,
  InputField,
  RecaptchaField,
  SubmitButton,
} from 'components/Form';
import Link, { RouterLink } from 'components/Link';
import { BodySmall } from 'components/Text';
import { trackClicked } from 'utils/analytics';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const EmailSignupForm = ({
  isModal,
  initialValues,
  showLoginModal,
  getLoginUrl,
  getThirdPartyLoginUrl,
  loginOverrideFn,
  onSubmit,
  compactView,
  hideLoginBlock,
}: {
  isModal: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialValues: Record<string, any>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showLoginModal: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getLoginUrl: ((...args: Array<any>) => any) | Record<string, any>;
  getThirdPartyLoginUrl: (
    arg0: 'facebook' | 'google'
  ) => Promise<string> | string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loginOverrideFn?: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: (...args: Array<any>) => any;
  compactView?: boolean;
  hideLoginBlock?: boolean;
}) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/function-component-definition, react/no-unstable-nested-components
  const LoginLink = ({
    email,
    ...props
  }: {
    children?: ReactNode;
    email?: string;
  }) => {
    if (loginOverrideFn) {
      return (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault();
            trackClicked('Log In');
            loginOverrideFn();
          }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      );
    }

    if (isModal && showLoginModal) {
      return (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault();
            trackClicked('Log In');
            showLoginModal(email);
          }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      );
    }

    return (
      <RouterLink
        // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
        to={getLoginUrl(email)}
        onClick={() => {
          trackClicked('Log In');
        }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    );
  };

  return (
    <Form
      data-qa-id="signup-email-form"
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={({ values: { email } }) => (
        <>
          <Box display="flex" flexWrap="wrap" mb={4} mt="-6px" mx="-6px">
            <Box m="6px">
              <GoogleButton
                onClick={async (e) => {
                  e.preventDefault();
                  const url = await getThirdPartyLoginUrl('google');
                  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
                  window.location = url;
                }}
                data-qa-id="google-oauth"
              />
            </Box>
            <Box m="6px">
              <FacebookButton
                onClick={async (e) => {
                  e.preventDefault();
                  const url = await getThirdPartyLoginUrl('facebook');
                  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
                  window.location = url;
                }}
                data-qa-id="facebook-oauth"
              />
            </Box>
          </Box>

          {!compactView && <Divider my={24} />}

          <GeneralError />

          <InputField
            name="email"
            label={getText('Email')}
            type="email"
            placeholder={getText('casey.smith@example.com')}
          />

          {(!compactView || email) && <RecaptchaField />}

          <Box mt={[16, null, 40]}>
            <SubmitButton width="100%" size="large">
              {getText('Sign up')}
            </SubmitButton>
          </Box>

          {!hideLoginBlock && (
            <Box mt={[16, null, 32]}>
              <BodySmall textAlign="center">
                {getText('Already have an account?')}{' '}
                <LoginLink email={email}>{getText('Log in')}</LoginLink>
              </BodySmall>
            </Box>
          )}
        </>
      )}
    />
  );
};

export default EmailSignupForm;
